import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import  '@mui/material/styles';
import Typography from '@mui/material/Typography';
import './dnd.css';

import EmailIcon from '@material-ui/icons/AssignmentTwoTone';

import {faBox, faFileExcel, faFan, faGlobe, faMouse, faKeyboard, faEnvelope, faCalculator, faPhotoVideo, faUser, faMicrochip, faFile, faFilePdf, faRocket} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import mapIcon from './NodeTypeToIconMap';
import ViewIcon from '@material-ui/icons/Visibility';

import { LightTooltip } from './LightTooltip';
import IconButton from "@material-ui/core/IconButton";

const icons={
  "Building Blocks":faBox,
  "Mouse":faMouse,
  "Keyboard":faKeyboard,
  "Browser":faGlobe,
  "File":faFile,
  "Processing":faMicrochip,
  "Math":faCalculator,
  "Advanced":faRocket,
  "Media":faPhotoVideo,
  "Excel":faFileExcel,
  "PDF":faFilePdf,
  "Email":faEnvelope,
  "System":faFan,
  "User Interaction":faUser,


}



//mostly not used
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 400,
    height:800,
    // backgroundColor:'#f2f2f2',
  },
});

export default function TableDesignView(props) {
  var classes = useStyles();
  // var nodesSelected = props.selectedNodes

  if (props.styles != null){
    classes = props.styles;
  }

  const [expanded, setExpanded] = React.useState([]);
  const [selected, setSelected] = React.useState([]);


  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    setSelected(nodeIds);
  };

  const onDragStart = (event, name, type, classType) => {
    event.dataTransfer.setData('application/reactflow', type);
    console.log(type)
    event.dataTransfer.setData('name', name);
    event.dataTransfer.setData('classType', classType);
    event.dataTransfer.effectAllowed = 'move';
  };

  //console.log(props.data)

  const designerIconStyle = {
    // backgroundImage:'radial-gradient(#a5a5a5, royalblue)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px'
    backgroundImage:'linear-gradient(to bottom right, #a5a5a5, royalblue)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px'
    // backgroundImage:'linear-gradient(to bottom right, #feb100, #8da5ed)', color:'white', padding:'10px', borderRadius:'25px', marginRight:'5px'
}

  const onChecked = (evt) =>{
    if (evt.target.checked  != true)
    {
      props.selectedNodes.delete(evt.target.id)
    }// var color = evt.target.style.background
    // if (color == 'lightgrey')
    //   color = 'white'
    // else
    //   color = 'lightgrey'
    // evt.target.style.background = color   
    // var list = document.getElementsByName('selectdiv')
    // for (var i = 0; i < 10; i++) {
    //   list[i].style.background = color
    // }
    else
    {
      props.selectedNodes.add(evt.target.id)   
    }
      // console.log(props.selectedNodes) 
  } 

  // const isChecked = (id)=>{
  //   if ( nodesSelected.has(id) ) return true
  //   return false
  // }

  const renderTableView = () =>{
    return options.map(item => {
      var data = item['data']
      var selectedStyle = {
        background:'white', margin:'10px', padding: '5px', color:'royalblue', textAlign:'center', borderRadius:'5px', boxShadow:'1px 1px 2px 2px lightgrey',
        border: '2px solid skyblue'
      }
      var style = {      
        background:'white', margin:'10px', padding: '5px', color:'royalblue', textAlign:'center', borderRadius:'5px', boxShadow:'1px 1px 2px 2px lightgrey'}

      if (item == props.selectedElement) style = selectedStyle

      return (
          <div   style={style} >
            <div  className = 'row' onClick={()=>{if (item['data']['label'] != 'Start') props.setSelectedElement(item)}} >
            {
              item['data']['label'] != 'Start'?  
              <input type='checkbox'  style={{margin:'10px'}} id={item['id']} onChange={onChecked}/>
              :
              <div/>
            }
            {mapIcon(item['type'])}
            <label  style={{background:'inherit'}}  className='actionlabel'>{item['data']['label']}</label>
            <br/>

            {/* {
              item['data']['label'] != 'Start'?  
              <LightTooltip title="Action Details">
              <IconButton size='small' onClick={()=>props.setSelectedElement(item)}>
                <ViewIcon style={{color:'#feb200'}} />
              </IconButton>
              </LightTooltip>

            :
            <div/>
            } */}

            </div>

          </div>
        )

    });
  }

  var id = 0;
 const handleClick = (id) => {
  // const selectedItem = this.state.data[index];
  }
  var elements = props.elements
  var options = []
  console.log(elements)
  for (let i = 0; i <elements.length;i++)
  {
      var item = elements[i]['data']
      if (item != undefined){
        // var option = {label: item['label'], value: i+1}
        options.push(elements[i])
      }
  }
  // console.log(options)
  // You can also pass the array of preselected options;
  const myselected = [1];
  const onChange = (selectedValues) => {
    // handle selected values here
  };

  var style = 
    { 
      height: '600px',  
      overflow: 'auto',           
      margin:'auto', width:'400px'
    } 

      return (
      <div className='comtainer'  style={style}>
        <div style={{textAlign:'center'}}>
          Actions:{options.length-1} 
        </div>
        {renderTableView()}
      </div>
    );
  }
